/**
 * Marinovel 品牌 - Welfare 页面配置
 */
import { welfareCommonConfig } from './common'
import type { WelfarePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

export const theme = {
  btnBg: '#EEF4FF',
  btnText: brandTheme.primaryColor,
  coinsColor: brandTheme.primaryColor,
} as const

export const resources = {
  homeBg: '/images/marinovel/bg.png',
  welfareGold: '/images/marinovel/welfare-gold.png',
  welfareBox: '/images/marinovel/welfare-box.png',
} as const

export const welfareConfig: WelfarePageConfig = {
  theme,
  resources,
  texts: welfareCommonConfig.texts,
}
